angular.module('psModule').factory('AlertService', function ($resource) {
    return $resource('./api/alert/:action', {}, {
        'getMessage': {method: 'GET', params: {action: 'message'}}
    });
});
